// extracted by css-extract-rspack-plugin
export default {"mark":"TW6AwzRIBfQK_LVu"};